import React, { useState, useEffect, useRef , useMemo ,useCallback } from 'react';
//import { Clock, CheckCircle, XCircle, AlertCircle, Globe, IndianRupee, DollarSign, LogOut, User, Trophy, TrendingUp, BookOpen, Target, RefreshCw, Eye, EyeOff, Gift } from 'lucide-react';
import { Clock, CheckCircle, XCircle, AlertCircle, Globe, IndianRupee, DollarSign, Award   ,LogOut, User, Trophy, TrendingUp, BookOpen, Target, RefreshCw, Eye, EyeOff, Gift, Shield } from 'lucide-react';
import PasswordStrengthIndicator from './PasswordStrengthIndicator';
import ChapterExamSelector from './ChapterExamSelector';
import ExamInterface from './ExamInterface';
import { Buffer } from 'buffer';
import ExamReview from './ExamReview';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import HeroSection from './HeroSection';
import CertificateGenerator from './CertificateGenerator';
import useSEO from './hooks/useSEO';

// ⬇️ add this new state



// const CURRENCIES = {
//      IN: { code: 'INR', examPrice: 1400, display: '₹1,400' },
//      US: { code: 'USD', examPrice: 16, display: '$16' }
//    };

const CURRENCIES = {
  IN: { code: 'INR', examPrice: 1400, display: '₹1,400' },
  US: { code: 'USD', examPrice: 16, display: '$16' }
};

const EXAM_TYPE_LABELS = {
  certification: "Full Certification",
  full: "Random Practice",
  mixed: "Mixed Practice",
  random: "Random Practice",
  chapter: "Chapter Focus",
 // focused: "Focused Exam",  // ✅ ADD THIS
};
function App() {
  const [lastAttempt, setLastAttempt] = useState(null);
  const [userCountry, setUserCountry] = useState('DEFAULT');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false); 
  const [selectedJavaVersion, setSelectedJavaVersion] = useState('17'); // Default to Java 17
  const [currentPage, setCurrentPage] = useState('landing'); // landing, register, login, dashboard, exam
  const [user, setUser] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [examHistory, setExamHistory] = useState([]);
  const [trialError, setTrialError] = useState(null);
  const [paymentError, setPaymentError] = useState(null);
  
  // New exam configuration state
  const [examConfig, setExamConfig] = useState(null);
  const [timeRemaining, setTimeRemaining] = useState(65 * 60);
  const [examSubmitted, setExamSubmitted] = useState(false);
  const [score, setScore] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // Form states
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  
  
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://a9csjxv6ha.execute-api.us-east-1.amazonaws.com/prod';
  const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID || 'rzp_test_RKwgMpiTTRCvF7';
  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('token') && params.get('email')) {
      setShowResetPassword(true);
      setCurrentPage('reset-password');
    }
  }, []);


useEffect(() => {
  const navEl = document.getElementById('nav');
  if (!navEl) return;
  
  // Hide nav whenever user is logged in (no matter which page)
  navEl.style.display = user ? 'none' : 'block';
}, [user]);


 useEffect(() => {
  // Clear stale auth data if user arrives from email verification
  const urlParams = new URLSearchParams(window.location.search);
  const fromVerification = urlParams.get('verified');
  
  if (fromVerification === 'true') {
    console.log('🔄 User arrived from email verification - clearing old auth data');
    
    // Clear any old auth data to force fresh login
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    sessionStorage.clear();  // ✅ ADD THIS LINE
    setAuthToken(null);
    setUser(null);
    setCurrentPage('login');
    
    // Clean URL by removing the ?verified=true parameter
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}, []);





const handleLogout = useCallback(() => {
  // Clear all storage items
  localStorage.removeItem('authToken');
  localStorage.removeItem('userData');
  sessionStorage.clear();
  
  // ✅ Extra safety: Remove any items that got set to "undefined" string
  if (localStorage.getItem('authToken') === 'undefined') {
    localStorage.removeItem('authToken');
  }
  if (localStorage.getItem('userData') === 'undefined') {
    localStorage.removeItem('userData');
  }
  
  // Clear all state
  setAuthToken(null);
  setUser(null);
  setQuestions([]);
  setExamConfig(null);
  setTimeRemaining(65 * 60);
  setExamSubmitted(false);
  setScore(0);
  setError(null);
  setTrialError(null);
  setPaymentError(null);
  
  setCurrentPage('landing');
  
  console.log('✅ Logged out and cleared all data');
}, []);

const makeAuthenticatedRequest = useCallback(
  async (url, options = {}) => {
    const headers = {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    };

    const token = localStorage.getItem('authToken');
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(url, {
      ...options,
      headers
    });

    // 🔒 Session / auth invalid
    if (response.status === 401) {
      alert(
        'For security reasons, only one browser session is allowed at a time. Your session has expired or you logged in from another device or browser. Please log in again'
      );
      handleLogout();
      throw new Error('SESSION_INVALID');
    }

    return response;
  },
  [handleLogout] // ✅ THIS fixes the ESLint warning
);

const validateAuthToken = useCallback(async () => {
  try {
    const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/validate-token`);
    return response.ok;
  } catch (e) {
    return false;
  }
}, [makeAuthenticatedRequest]);

//   const checkAuthStatus = useCallback(async () => {
//   const token = localStorage.getItem('authToken');
//   const userData = localStorage.getItem('userData');

//   // ✅ ADD THIS CHECK
//   if (!token || !userData || token === 'undefined' || userData === 'undefined') {
//     console.log('🔒 No valid auth data found');
//     return;
//   }
//   if (token && userData) {
//     try {
//       const user = JSON.parse(userData);
//       const tokenData = JSON.parse(Buffer.from(token, 'base64').toString());

//       //if (tokenData.exp < Date.now()) {
//       if (tokenData.exp * 1000 < Date.now()) {

//         console.log('🔒 Token expired, logging out');
//         handleLogout();
//         return;
//       }

//       try {
//         const subResponse = await fetch(
//           `${API_ENDPOINT}/subscription-status?email=${user.email}`,
//           {
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           }
//         );

//         if (subResponse.ok) {
//           const subData = await subResponse.json();
          
//           const updatedUser = {
//             ...user,
//             hasActiveSubscription: subData.hasActiveSubscription || false,
//             subscriptionType: subData.subscriptionType || null,
//             questionsRemaining: subData.questionsRemaining || 0
//           };

//           localStorage.setItem('userData', JSON.stringify(updatedUser));
//           setUser(updatedUser);
//           setAuthToken(token);
//           setCurrentPage(updatedUser.hasActiveSubscription ? 'dashboard' : 'payment');
//         } else {
//           console.warn('⚠️ Subscription validation failed');
//           handleLogout();
//         }
//       } catch (error) {
//         console.error('❌ Failed to validate subscription:', error);
//         handleLogout();
//       }
//     } catch (error) {
//       console.error('Invalid auth data:', error);
//       handleLogout();
//     }
//   }
// }, [handleLogout, API_ENDPOINT]);

const checkAuthStatus = useCallback(async () => {
  const urlParams = new URLSearchParams(window.location.search);

  // 🔓 PUBLIC FLOWS — NEVER CHECK AUTH
  if (
    (urlParams.get('token') && urlParams.get('email')) ||   // password reset
    urlParams.get('verified') === 'true'                    // email verification
  ) {
    console.log('🔓 Public flow detected — skipping auth check');
    return;
  }

  const token = localStorage.getItem('authToken');
  const userData = localStorage.getItem('userData');

  // 🚫 No auth data
  if (!token || !userData || token === 'undefined' || userData === 'undefined') {
    console.log('🔒 No valid auth data found');
    return;
  }

  try {
    const user = JSON.parse(userData);
    const tokenData = JSON.parse(
      Buffer.from(token, 'base64').toString()
    );

    // ⏳ Token expired
    if (tokenData.exp * 1000 < Date.now()) {
      console.log('🔒 Token expired, logging out');
      handleLogout();
      return;
    }

    // 🔍 Validate subscription
    const subResponse = await fetch(
      `${API_ENDPOINT}/subscription-status?email=${user.email}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!subResponse.ok) {
      console.warn('⚠️ Subscription validation failed');
      handleLogout();
      return;
    }

    const subData = await subResponse.json();

    const updatedUser = {
      ...user,
      hasActiveSubscription: subData.hasActiveSubscription || false,
      subscriptionType: subData.subscriptionType || null,
      questionsRemaining: subData.questionsRemaining || 0
    };

    localStorage.setItem('userData', JSON.stringify(updatedUser));
    setUser(updatedUser);
    setAuthToken(token);
    setCurrentPage(
      updatedUser.hasActiveSubscription ? 'dashboard' : 'payment'
    );

  } catch (error) {
    console.error('❌ Invalid auth data:', error);
    handleLogout();
  }
}, [handleLogout, API_ENDPOINT]);


  
// useEffect(() => {
//   // Skip auth check if coming from email verification
//   const urlParams = new URLSearchParams(window.location.search);
//   if (urlParams.get('verified') === 'true') {
//     console.log('⏭️ Skipping auth check - verification useEffect will handle it');
//     return;
//   }
  
//   checkAuthStatus();
// }, [checkAuthStatus]);

useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);

  // ✅ Skip auth check if coming from email verification
  if (urlParams.get('verified') === 'true') {
    console.log('⏭️ Skipping auth check - verification flow');
    return;
  }

  // ✅ Skip auth check if coming from password reset link
  if (urlParams.get('token') && urlParams.get('email')) {
    console.log('🔐 Skipping auth check - password reset flow');
    return;
  }

  checkAuthStatus();
}, [checkAuthStatus]);





// useEffect(() => {
//   const urlParams = new URLSearchParams(window.location.search);
//   const token = urlParams.get('token'); // PayPal order ID
//   const payerId = urlParams.get('PayerID');
  
//   if (!token || !payerId) {
//     return; // No PayPal parameters, exit early
//   }
  
//   // ✅ CRITICAL FIX: Prevent duplicate processing
//   const processingKey = `paypal_processed_${token}`;
  
//   // Check if this order was already processed
//   if (sessionStorage.getItem(processingKey)) {
//     console.log('⏭️ Order already processed, skipping duplicate verification');
//     return;
//   }
  
//   // Mark this order as being processed
//   sessionStorage.setItem(processingKey, 'true');
//   console.log('🔄 Processing PayPal order:', token);
  
//   // Only process if not already on processing page
//   if (currentPage === 'paypal-processing') {
//     return;
//   }
  
//   // ✅ Define verification logic inline
//   const verifyPayPalPayment = async () => {
//     setCurrentPage('paypal-processing');
//     setIsLoading(true);
    
//     try {
//       // Get user from localStorage if not in state yet
//       const currentUser = user || JSON.parse(localStorage.getItem('userData') || 'null');
//       const currentToken = authToken || localStorage.getItem('authToken');
      
//       if (!currentUser || !currentUser.email) {
//         throw new Error('User session not found. Please login again.');
//       }
      
//       console.log('🔍 Verifying PayPal payment for:', currentUser.email);
      
// const response = await fetch(`${API_ENDPOINT}/verify-paypal-payment`, {
//   method: 'POST',
//   headers: {
//     'Authorization': `Bearer ${currentToken}`,
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify({
//     orderId: token,  // ✅ CORRECT
//     userEmail: currentUser.email,
//     environment: process.env.NODE_ENV === 'production' ? 'live' : 'sandbox'
//   })
// });

//       if (!response.ok) {
//         throw new Error(`HTTP ${response.status}: ${response.statusText}`);
//       }

//       const data = await response.json();
      
//     if (data.verified) {
//   // ✅ Update storage
//   localStorage.setItem('authToken', data.token);
//   localStorage.setItem('userData', JSON.stringify(data.user));
  
//   // ✅ Clean URL before reload
//   window.history.replaceState({}, document.title, window.location.pathname);
  
//   // ✅ Force full page reload to pick up new token
//   alert('Payment successful! Your subscription is now active. Redirecting to dashboard...');
//   window.location.href = '/';  // Full reload
// } else {
//         throw new Error('Payment verification failed');
//       }
//     } catch (error) {
//       console.error('❌ PayPal verification failed:', error);
//       setError(`Payment verification failed: ${error.message}`);
//       setCurrentPage('payment');
//     } finally {
//       setIsLoading(false);
//     }
//   };
  
//   // Execute verification
//   verifyPayPalPayment();
  
// }, [currentPage, user, authToken, API_ENDPOINT, setCurrentPage, setIsLoading, setUser, setAuthToken, setError]);
  const paypalHandledRef = useRef(false);

useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const orderId = params.get('token');
  const payerId = params.get('PayerID');

  if (!orderId || !payerId) return;

  // 🔒 HARD STOP — runs only once per page load
  if (paypalHandledRef.current) {
    console.log('⏭️ PayPal already handled');
    return;
  }
  paypalHandledRef.current = true;

  const verify = async () => {
    try {
      setIsLoading(true);
      setCurrentPage('paypal-processing');

      const currentUser =
        user || JSON.parse(localStorage.getItem('userData') || 'null');
      const token =
        authToken || localStorage.getItem('authToken');

      if (!currentUser?.email || !token) {
        throw new Error('Session expired. Please login again.');
      }

      console.log('🔍 Verifying PayPal order:', orderId);

      const res = await fetch(`${API_ENDPOINT}/verify-paypal-payment`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderId,
          userEmail: currentUser.email,
          environment:
            process.env.NODE_ENV === 'production' ? 'live' : 'sandbox'
        })
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      if (!data.verified) throw new Error('Verification failed');

      // ✅ Persist auth
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('userData', JSON.stringify(data.user));

      // ✅ REMOVE PayPal params IMMEDIATELY
      window.history.replaceState({}, document.title, '/');

      // alert('Payment successful!');
      // window.location.reload();
      alert('🎉 Payment successful!\n\nYour subscription is now active. \n\nClick OK to continue to your dashboard.');
      window.location.reload();

    } catch (err) {
      console.error('❌ PayPal verification failed:', err);
      paypalHandledRef.current = false; // allow retry
      setError(err.message);
      setCurrentPage('payment');
    } finally {
      setIsLoading(false);
    }
  };

  verify();

  // 🚫 EMPTY dependency array (intentional)
}, []);


  const handleForgotPasswordClick = () => {
    setShowForgotPassword(true);
    setCurrentPage('forgot-password');
  };

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
    setShowResetPassword(false);
    setCurrentPage('login');
    window.history.replaceState({}, document.title, window.location.pathname);
  };

  



  const handleResetPasswordSuccess = () => {
    setShowResetPassword(false);
    setCurrentPage('login');
    window.history.replaceState({}, document.title, window.location.pathname);
    alert('Password reset successful! Please login with your new password.');
  };




//   const fetchExamHistory = async () => {
//   try {
//     const response = await makeAuthenticatedRequest(
//       `${API_ENDPOINT}/java-cert-get-exam-history?email=${user.email}`
//     );
    
//     if (response.ok) {
//       const data = await response.json();
//       setExamHistory(data.examHistory || []);
//     }
//   } catch (error) {
//     console.error('Failed to fetch exam history:', error);
//   }
// };

const fetchExamHistory = useCallback(async () => {
  if (!authToken) return;

  try {
    const response = await makeAuthenticatedRequest(
      `${API_ENDPOINT}/java-cert-get-exam-history`
    );

    if (response.ok) {
      const data = await response.json();
      setExamHistory(data.examHistory || []);
    }
  } catch (error) {
  if (error.message === 'SESSION_INVALID') return;
  console.error('Failed to fetch exam history:', error);
}
}, [authToken, API_ENDPOINT, makeAuthenticatedRequest]);


useEffect(() => {
  if (currentPage === 'dashboard') {
    fetchExamHistory();
  }
}, [currentPage, fetchExamHistory]);
  



const handleRegister = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setError(null);

  try {
    const response = await fetch(`${API_ENDPOINT}/register`, {

      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (response.status === 503 && data.disabled) {
      setError('Registration is temporarily disabled. Please check back later.');
    } else if (response.ok) {
  // ✅ Show success message and redirect to login
  setError(null);
  setFormData({ email: formData.email, password: '', name: '' });
  setCurrentPage('login');
  
  // ✅ Use setTimeout to ensure alert shows after page change
  setTimeout(() => {
    alert('Registration successful! Please check your email for a verification link.');
  }, 100);
} else {
      setError(data.error || 'Registration failed');
    }
  } catch (error) {
    console.error('Registration error:', error);
    setError('Registration failed. Please try again.');
  } finally {
    setIsLoading(false);
  }
};



 const handleLogin = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setError(null);

  try {
    const response = await fetch(`${API_ENDPOINT}/login`, {

      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: formData.email,
        password: formData.password
      })
    });

    const data = await response.json();

    if (response.ok) {
      localStorage.setItem('authToken', data.token);
      setAuthToken(data.token);

      try {
        const subResponse = await fetch(
          `${API_ENDPOINT}/subscription-status?email=${data.user.email}`,
          {
            headers: {
              'Authorization': `Bearer ${data.token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        if (subResponse.ok) {
          const subData = await subResponse.json();
          
          const verifiedUser = {
            ...data.user,
            hasActiveSubscription: subData.hasActiveSubscription || false,
            subscriptionType: subData.subscriptionType || null,
            questionsRemaining: subData.questionsRemaining || 0,
            trialUsed: subData.trialUsed || false
          };

          localStorage.setItem('userData', JSON.stringify(verifiedUser));
          setUser(verifiedUser);
          setError(null);
          setFormData({ email: '', password: '', name: '' });
          setCurrentPage(verifiedUser.hasActiveSubscription ? 'dashboard' : 'payment');
        } else {
          console.warn('⚠️ Could not verify subscription, showing payment page');
          localStorage.setItem('userData', JSON.stringify(data.user));
          setUser(data.user);
          setCurrentPage('payment');
        }
      } catch (subError) {
        console.error('❌ Subscription check failed:', subError);
        localStorage.setItem('userData', JSON.stringify(data.user));
        setUser(data.user);
        setCurrentPage('payment');
      }
    } else {
      setError(data.error || 'Login failed');
    }
  } catch (error) {
    console.error('Login error:', error);
    setError('Login failed. Please try again.');
  } finally {
    setIsLoading(false);
  }
};





const handlePayPalReturn = async (orderId) => {
  setCurrentPage('paypal-processing');
  setIsLoading(true);
  
  try {
    // ✅ Get user from localStorage if not in state yet
    const currentUser = user || JSON.parse(localStorage.getItem('userData') || 'null');
    const currentToken = authToken || localStorage.getItem('authToken');
    
    if (!currentUser || !currentUser.email) {
      throw new Error('User session not found. Please login again.');
    }
    
    console.log('🔍 Verifying PayPal payment for:', currentUser.email);
    
const response = await fetch(`${API_ENDPOINT}/go-verify-paypal-payment-lambda`, {
  method: 'POST',
  headers: {
    'Authorization': `Bearer ${currentToken}`,
    'Content-Type': 'application/json'
  },
body: JSON.stringify({
    orderId: orderId,  // ✅ CORRECT: Use the function parameter
    userEmail: currentUser.email,
    environment: process.env.NODE_ENV === 'production' ? 'live' : 'sandbox'
})
});

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    
    if (data.verified) {
      const updatedUser = { ...currentUser, ...data.user };
      localStorage.setItem('userData', JSON.stringify(updatedUser));
      localStorage.setItem('authToken', data.token);
      setUser(updatedUser);
      setAuthToken(data.token);
      
      window.history.replaceState({}, document.title, window.location.pathname);
      
      setCurrentPage('dashboard');
      alert('Payment successful! Your subscription is now active.');
    } else {
      throw new Error('Payment verification failed');
    }
  } catch (error) {
    console.error('❌ PayPal verification failed:', error);
    setError(`Payment verification failed: ${error.message}`);
    setCurrentPage('payment');
  } finally {
    setIsLoading(false);
  }
};
  const handleActivateFreeTrial = async () => {
  if (!authToken) {
    //setError('Please login first');
    setTrialError('Please login first');
    return;
  }

  setIsLoading(true);
  //setError(null);
  setTrialError(null); 
  
  try {
    const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/activate-free-trial`, {
      method: 'POST',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || data.error || 'Failed to activate free trial');
    }

    if (data.success) {
      // Update user state with trial subscription
      const updatedUser = { 
        ...user, 
        hasActiveSubscription: true, 
        subscriptionType: 'trial' 
      };
      
      localStorage.setItem('userData', JSON.stringify(updatedUser));
      setUser(updatedUser);
      
      alert('🎉 ' + data.message);
      setCurrentPage('dashboard');
    }
  } catch (error) {
  if (error.message === 'SESSION_INVALID') return;
  console.error('Free trial activation failed:', error);
  setTrialError(error.message);
}
 finally {
    setIsLoading(false);
  }
};

  
const initiateRazorpayCheckout = (orderData) => {
  if (!window.Razorpay) {
    setError('Razorpay script not loaded. Please refresh the page.');
    setIsLoading(false);
    return;
  }

  const options = {
    key: RAZORPAY_KEY_ID,
    amount: orderData.amount,
    currency: orderData.currency,
    name: 'Java Certification Practice Pro',
    description: 'Full Access Subscription - 6 months',  // ✅ FIXED - Static text
    order_id: orderData.orderId,
    prefill: {
      name: orderData.userName,
      email: orderData.userEmail,
    },
    theme: { color: '#4F46E5' },
    handler: async function (response) {
      await verifyPayment(response);
    },
    modal: {
      ondismiss: function() {
        setIsLoading(false);
      }
    }
  };
  
  try {
    const rzp = new window.Razorpay(options);
    rzp.open();
  } catch (error) {
    console.error('Failed to open Razorpay:', error);
    setError('Failed to open payment gateway');
    setIsLoading(false);
  }
};

  const verifyPayment = async (paymentResponse) => {
    try {
      setIsLoading(true);
 const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/verify-payment`, {
  method: 'POST',
  body: JSON.stringify({
    razorpay_payment_id: paymentResponse.razorpay_payment_id,
    razorpay_order_id: paymentResponse.razorpay_order_id,
    razorpay_signature: paymentResponse.razorpay_signature,
    userEmail: user.email,
    environment: process.env.NODE_ENV === 'production' ? 'live' : 'test' // ✅ NEW
  })
});

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
  if (data.verified) {
  // ✅ Update storage
  localStorage.setItem('authToken', data.token);
  localStorage.setItem('userData', JSON.stringify(data.user));
  
  // ✅ Force full page reload to pick up new token
  // alert('Payment successful! Your subscription is now active. Redirecting to dashboard...');
  // window.location.href = '/';  // Full reload
  alert('🎉 Payment successful!\n\nYour subscription is now active. \n\nClick OK to go to your dashboard and start practicing.');
  window.location.href = '/';
} else {
  throw new Error('Payment verification failed');
}
    } catch (error) {
  if (error.message === 'SESSION_INVALID') return;
  console.error('Payment verification failed:', error);
  setError(`Payment verification failed: ${error.message}`);
}
 finally {
      setIsLoading(false);
    }
  };

  // Updated function to handle exam start with configuration
  const handleStartExam = async (config) => {
    setExamConfig(config);
    await loadQuestions(config);
  };

  // Updated loadQuestions function to accept exam configuration
 const loadQuestions = async (config) => {
  try {
    setIsLoading(true);
    setError(null);

    // 🔐 STEP 1: Validate subscription (protected endpoint)
    const subResponse = await makeAuthenticatedRequest(
      `${API_ENDPOINT}/subscription-status?email=${user.email}`
    );

    // ⛔ Session invalidation already handled inside makeAuthenticatedRequest
    if (!subResponse) return;

    if (!subResponse.ok) {
      const errData = await subResponse.json().catch(() => ({}));
      throw new Error(errData.message || 'Please verify your subscription status');
    }

    const subData = await subResponse.json();

    if (!subData.hasActiveSubscription) {
      setError('Your subscription has expired. Please renew to continue.');
      setCurrentPage('payment');
      return;
    }

    if (
      subData.subscriptionType === 'trial' &&
      subData.questionsRemaining <= 0
    ) {
      setError(
        'You have used all your free trial questions. Please subscribe for unlimited access.'
      );
      setCurrentPage('payment');
      return;
    }

    // 📌 STEP 2: Determine questions endpoint
    let endpoint;
    let queryParams;

    // if (config.type === 'focused') {
    //   endpoint = `${API_ENDPOINT}/java-cert-get-focus-questions`;
    //   queryParams = `chapter=${encodeURIComponent(config.chapter)}`;
    //   console.log('🎯 Using focused questions endpoint:', endpoint);
    // } else {
      endpoint = `${API_ENDPOINT}/questions`;
      const params = new URLSearchParams({
        examType: config.type,
        javaVersion: selectedJavaVersion, // ✅ NEW: Add version parameter
        ...(config.chapter && { chapter: config.chapter }),
        ...(config.difficulty && { difficulty: config.difficulty }),
        ...(config.testNumber && { testNumber: config.testNumber })
      });
      queryParams = params.toString();
      console.log('📋 Using standard questions endpoint:', endpoint);
    //}

    console.log('🚀 Loading questions with config:', config);
    console.log('📋 Java Version:', selectedJavaVersion); // ✅ NEW
    // 📘 STEP 3: Fetch questions (protected endpoint)
    const response = await makeAuthenticatedRequest(
      `${endpoint}?${queryParams}`
    );

    // ⛔ Session invalidation already handled
    if (!response) return;

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();

    if (!data.questions || data.questions.length === 0) {
      throw new Error('No questions received from server');
    }

    // 🧠 STEP 4: Initialize exam state
    setQuestions(data.questions);
    setCurrentPage('exam');

    const actualQuestionCount = data.questions.length;
    let calculatedTimeLimit;

    // if (config.type === 'focused') {
    //   calculatedTimeLimit = config.isPracticeMode
    //     ? Math.ceil(actualQuestionCount * 3)
    //     : Math.ceil(actualQuestionCount * 2);

    //   console.log(
    //     `⏱️ Focused exam: ${actualQuestionCount} questions = ${calculatedTimeLimit} minutes`
    //   );
    // } else {
      calculatedTimeLimit = config.timeLimit || 120;
    //}

    setTimeRemaining(calculatedTimeLimit * 60);
    setExamSubmitted(false);
    setScore(0);
  } catch (error) {
    // 🔒 Session invalid already handled globally
    if (error.message === 'SESSION_INVALID') return;

    console.error('❌ Failed to load questions:', error);
    setError(error.message || 'Failed to load questions');
  } finally {
    setIsLoading(false);
  }
};

 



const handleSubmitExam = async (examAnswers) => { 
  setIsLoading(true);
  setError(null);

  try {
    // Build answers payload
    const payloadAnswers = {};
    questions.forEach((q, idx) => {
      const sel = examAnswers[idx];
      if (sel !== undefined && q?.questionId && Array.isArray(q.options)) {
        if (Array.isArray(sel)) {
          payloadAnswers[q.questionId] = sel.map(i => q.options[i]);
        } else {
          payloadAnswers[q.questionId] = [q.options[sel]];
        }
      }
    });

    console.log("📤 Submitting exam with:", {
      totalQuestions: questions.length,
      answered: Object.keys(payloadAnswers).length,
      examType: examConfig?.type,
      chapter: examConfig?.chapter,
      testNumber: examConfig?.testNumber,
      timeSpent: ((examConfig?.timeLimit || 120) * 60) - timeRemaining
    });

    const calculatedScore = calculateScore(examAnswers);
    //const questionIds = questions.map(q => String(q.questionId));
    const questionIds = questions.map(q => Number(q.questionId));


    console.log("🧩 QuestionIds being sent:", questionIds.slice(0, 10));

    // ✅ Build payload with smart testNumber handling
    // const payload = {
    //   examId: 'java-cert-basic',
    //   examType: examConfig?.type || 'full',
    //   answers: payloadAnswers,
    //   questionIds,
    //   timeSpent: ((examConfig?.timeLimit || 120) * 60) - timeRemaining
    // };

    // // ✨ Set chapter and testNumber based on exam type
    // if (examConfig?.type === 'certification') {
    //   // Certification: has testNumber, no chapter
    //   payload.testNumber = examConfig.testNumber || 1;
    //   payload.chapter = 'N/A';
    //   console.log('📋 Certification test #' + payload.testNumber);
    // } else if (examConfig?.type === 'focused') {
    //   // Focused: has chapter (set name), no testNumber
    //   payload.testNumber = null;
    //   payload.chapter = examConfig.chapter || 'N/A';
    //   console.log('🎯 Focused exam:', payload.chapter);
    // } else {
    //   // Full/Mixed: no testNumber, no chapter
    //   payload.testNumber = null;
    //   payload.chapter = 'N/A';
    //   console.log('🎲 ' + examConfig?.type + ' exam');
    // }
//const questionIds = questions.map(q => Number(q.questionId));

let testNumber = 0;
let chapter = 'N/A';

// if (examConfig?.type === 'certification') {
//   testNumber = Number(examConfig.testNumber || 1);
// } else if (examConfig?.type === 'focused') {
//   chapter = examConfig.chapter || 'N/A';
// }

const payload = {
  examId: 'java-cert-basic',
  examType: examConfig?.type || 'full',
  answers: payloadAnswers,
  questionIds,
  testNumber,
  chapter,
  javaVersion: examConfig?.javaVersion || selectedJavaVersion || '17',  // ← ADD
  timeSpent: ((examConfig?.timeLimit || 120) * 60) - timeRemaining
};

    console.log("📤 Final payload:", JSON.stringify(payload, null, 2));

    const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/submit-exam`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    let finalScore = calculatedScore;
    let resultData = null;

    if (response.ok) {
      const data = await response.json();
      console.log("📥 Lambda response:", data);
      finalScore = data?.result?.score ?? calculatedScore;
      resultData = data?.result;
    } else {
      console.warn("⚠️ Lambda returned non-200:", response.status);
    }

    // ✅ Deep copy of full question objects to preserve text, code, and explanation
    const clonedQuestions = questions.map(q => ({
      questionId: q.questionId,
      question: q.question,
      code: q.code,
      options: q.options,
      correctAnswer: q.correctAnswer,
      correctAnswers: q.correctAnswers,
      explanation: q.explanation,
      chapter: q.chapter,
      difficulty: q.difficulty,
    }));

    setLastAttempt({
      questions: clonedQuestions,
      answers: payloadAnswers,
      score: finalScore,
      percentage: resultData?.percentage ?? ((finalScore / questions.length) * 100).toFixed(2),
      examType: examConfig?.type || 'full',
      chapter: examConfig?.chapter,
      testNumber: examConfig?.testNumber || null,
      submittedAt: new Date().toISOString()
    });

    setScore(finalScore);
    setExamSubmitted(true);
    setCurrentPage('results');

  } catch (error) {
    if (error.message === 'SESSION_INVALID') return;
    console.error("❌ Failed to submit exam:", error);
    const fallbackScore = calculateScore(examAnswers);

    setLastAttempt({
      questions,
      answers: examAnswers,
      score: fallbackScore,
      percentage: ((fallbackScore / questions.length) * 100).toFixed(2),
      //examType: examConfig?.type || 'full',
      examType:examConfig?.type === 'focused' ? 'chapter' : examConfig?.type || 'full',
      chapter: examConfig?.chapter,
      testNumber: examConfig?.testNumber || null,
      submittedAt: new Date().toISOString()
    });

    setScore(fallbackScore);
    setExamSubmitted(true);
    setCurrentPage('results');
  } finally {
    setIsLoading(false);
  }
};

  // const calculateScore = (examAnswers) => {
  //   let correctAnswers = 0;
  //   questions.forEach((question, index) => {
  //     if (examAnswers[index] === question.correctAnswer) {
  //       correctAnswers++;
  //     }
  //   });
  //   return correctAnswers;
  // };
const calculateScore = (examAnswers) => {
  let correct = 0;

  questions.forEach((q, i) => {
    const userAnswer = examAnswers[i];

    if (Array.isArray(q.correctAnswers)) {
      if (
        Array.isArray(userAnswer) &&
        userAnswer.length === q.correctAnswers.length &&
        userAnswer.every(a => q.correctAnswers.includes(a))
      ) {
        correct++;
      }
    } else {
      if (userAnswer === q.correctAnswer) {
        correct++;
      }
    }
  });

  return correct;
};

  const styles = {
    container: {
      minHeight: '100vh',

background: `
  radial-gradient(circle at top center, rgba(255,255,255,0.4), transparent 60%),
  linear-gradient(135deg, #e9ecf3 0%, #cfd6e2 100%)
`,


      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    card: {
      backgroundColor: '#ffffff',
      
      borderRadius: '16px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
      border: 'none',
      overflow: 'hidden'
    },
    primaryButton: {
      background: 'linear-gradient(135deg, #1da314ff 0%, #52a95dff 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '12px',
      padding: '16px 32px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      width: '100%',
      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
    },
    secondaryButton: {
      backgroundColor: 'transparent',
      color: '#44a748ff',
      border: '2px solid #42a44fff',
      borderRadius: '12px',
      padding: '12px 24px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },
    input: {
      width: '100%',
      padding: '12px 16px',
      border: '2px solid #e2e8f0',
      borderRadius: '12px',
      fontSize: '16px',
      marginBottom: '16px',
      transition: 'border-color 0.3s ease'
    },
    formGroup: {
      marginBottom: '20px'
    },
    label: {
      display: 'block',
      marginBottom: '8px',
      fontWeight: '600',
      color: '#374151'
    }
  };

  // ✅ CORRECT - Calculate SEO config with useMemo FIRST
  const seoConfig = useMemo(() => {
    switch (currentPage) {
      case 'landing':
        return {
           title: 'Java SE 17 & 21 OCP Certification Practice Tests (1Z0-829 & 1Z0-830)',
           description: 'Master Java OCP certification with nearly 4,000 practice questions across 78 full-length tests. 1Z0-829 and 1Z0-830 exam prep with detailed explanations and free 30-question trial.',
            canonical: 'https://javaocp.clustermicro.com/',
        };
      
      case 'login':
        return {
          title: 'Login',
          description: 'Login to your Java OCP 17 & 21 practice account',
          noindex: true,
        };
      
      case 'register':
        return {
          title: 'Create Account',
          description: 'Create your account to start practicing for Java OCP 17 & 21 certification',
          noindex: true,
        };
      
      case 'payment':
        return {
          title: 'Choose Your Plan — Java OCP 17 & 21 Practice',
          description: 'Get 6 months of access to Java OCP 17 or Java OCP 21 practice tests for ₹1,400 (India) / $16 (International). Free 30-question trial included.',
          canonical: 'https://javaocp.clustermicro.com/pricing',
        };
      
      case 'dashboard':
        return {
          title: 'Dashboard',
          description: 'Your Java OCP 17 & 21 practice dashboard',
          noindex: true,
        };
      
      case 'exam':
  return {
    title: 'Practice Exam (Private)',
    description: 'Private exam session',
    noindex: true,
  };

case 'results':
  return {
    title: 'Exam Results (Private)',
    description: 'Private exam results',
    noindex: true,
  };

      
      case 'certificates':
        return {
          title: 'My Certificates',
          description: 'Your earned Java OCP practice certificates',
          noindex: true,
        };
      
      case 'review':
        return {
          title: 'Review Mistakes',
          description: 'Review your exam mistakes',
          noindex: true,
        };
      
      case 'privacy-policy':
        return {
          title: 'Privacy Policy',
          description: 'Privacy policy for Javaocp Java OCP 17 & 21 practice platform',
          canonical: 'https://javaocp.clustermicro.com/privacy-policy',
        };
      
      case 'terms':
  return {
    title: 'Terms and Conditions',
    description: 'Terms of service for Javaocp',
    canonical: 'https://javaocp.clustermicro.com/terms.html',
  };

case 'refund-policy':
  return {
    title: 'Refund Policy',
    description: 'Refund policy for Javaocp',
    canonical: 'https://javaocp.clustermicro.com/refund.html',
  };

case 'contact':
  return {
    title: 'Contact Us',
    description: 'Contact Javaocp support',
    canonical: 'https://javaocp.clustermicro.com/contact.html',
  };

      
      case 'forgot-password':
        return {
          title: 'Forgot Password',
          description: 'Reset your password',
          noindex: true,
        };
      
      case 'reset-password':
        return {
          title: 'Reset Password',
          description: 'Create new password',
          noindex: true,
        };
      
      case 'paypal-processing':
        return {
          title: 'Processing Payment',
          description: 'Processing your payment',
          noindex: true,
        };
      
      default:
        return {
          title: currentPage,
          description: 'JavaOCP - Java OCP 17 & 21 Practice',
          noindex: true,
        };
    }
  }, [currentPage]);

  // ✅ NOW call useSEO with the config
  useSEO(seoConfig);
  // PayPal Processing Page
if (currentPage === 'paypal-processing') {
  return (
    <div style={styles.container}>
      <div style={{maxWidth: '600px', margin: '0 auto', padding: '40px 20px'}}>
        <div style={{...styles.card, padding: '60px 40px', textAlign: 'center'}}>
          <RefreshCw 
            size={64} 
            style={{
              margin: '0 auto 24px',
              animation: 'spin 1s linear infinite',
              color: '#667eea'
            }} 
          />
          <h2 style={{fontSize: '24px', fontWeight: 'bold', marginBottom: '16px'}}>
            Processing Your Payment
          </h2>
          <p style={{color: '#64748b', fontSize: '16px'}}>
            Please wait while we verify your PayPal payment...
          </p>
        </div>
      </div>
      <style>
        {`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

// Add this near the top of your App() function, after the styles object
const mobileResponsiveCSS = `
  /* ========== MOBILE RESPONSIVE - Only applies on small screens ========== */
  
  @media (max-width: 768px) {
    /* ChapterExamSelector - Exam Type Grid: 4 cols → 2 cols */
    div[style*="grid-template-columns: 1fr 1fr 1fr 1fr"] {
      grid-template-columns: repeat(2, 1fr) !important;
      gap: 12px !important;
    }
    
    /* Payment Page - 3 cols → 1 col */
    div[style*="repeat(3, 1fr)"] {
      grid-template-columns: 1fr !important;
    }
    
    /* Header flex containers - stack vertically */
    div[style*="justify-content: space-between"][style*="align-items: center"] {
      flex-direction: column !important;
      gap: 12px !important;
      align-items: stretch !important;
    }
    
    /* Buttons - full width on mobile */
    button {
      min-width: unset !important;
    }
    
    /* User info box in ChapterExamSelector header */
    div[style*="position: absolute"][style*="top: 14px"] {
      position: relative !important;
      top: unset !important;
      right: unset !important;
      justify-content: center !important;
      margin-bottom: 12px !important;
    }
    
    /* Reduce padding on cards */
    div[style*="padding: 40px"] {
      padding: 20px !important;
    }
    
    div[style*="padding: 32px"] {
      padding: 16px !important;
    }
    
    /* Smaller titles */
    h1[style*="font-size: 36px"] {
      font-size: 24px !important;
    }
    
    h2[style*="font-size: 28px"] {
      font-size: 20px !important;
    }
  }
  
  @media (max-width: 480px) {
    /* Extra small screens - everything single column */
    div[style*="grid-template-columns: 1fr 1fr 1fr 1fr"],
    div[style*="grid-template-columns: 1fr 1fr"] {
      grid-template-columns: 1fr !important;
    }
    
    /* Even smaller padding */
    div[style*="padding: 24px"] {
      padding: 12px !important;
    }
  }
`;


  // Landing Page - RESPONSIVE TWO COLUMN LAYOUT
  // Landing Page - NEW LAYOUT
if (currentPage === 'landing') {
  
  return (
    <div style={styles.container}>
      <style>{`
        @media (max-width: 968px) {
          .two-column-grid {
            grid-template-columns: 1fr !important;
            gap: 24px !important;
          }
          .full-width-header {
            padding: 40px 20px 0 20px !important;
          }
        }
        @media (max-width: 480px) {
          .header-logo-section {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 8px !important;
          }
          .header-logo {
            width: 64px !important;
            height: 64px !important;
          }
          .header-domain {
            font-size: 20px !important;
          }
          .header-title {
            font-size: 22px !important;
          }
          .header-maintenance {
            font-size: 16px !important;
          }
          .header-description {
            font-size: 15px !important;
          }
        }
      `}</style>
      
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '18px 20px'
      }}>
        
        {/* FULL WIDTH HEADER */}
        {/* FULL WIDTH HEADER */}
<div style={{
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  padding: '40px',
  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
  border: '1px solid rgba(0,0,0,0.08)',
  textAlign: 'left',
  marginBottom: '18px'
}}>
  {/* Logo + Domain */}
  <div className="header-logo-section" style={{
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '24px',
  }}>
    <p className="header-domain" style={{
      fontSize: '44px',
      margin: 0,
      fontWeight: '500',
      color: '#111827',
      fontFamily: '"Segoe UI", Roboto, sans-serif',
      letterSpacing: '-0.3px',
      paddingBottom: '16px',
      borderBottom: '2px solid #e5e7eb',  
      marginBottom: '24px',
      textAlign: 'center',
      display: 'block',
      width: '100%',
    }}>
      <span style={{ color: '#fd0606' }}>Java</span>ocp.clustermicro.com
    </p>
  </div>

  {/* Title */}
  <h1 className="header-title" style={{
    fontSize: '24px',
    margin: '0 0 16px 0',
    lineHeight: '1.3',
    color: '#000000',
  }}>
    Master Java SE 17 & 21 Certification (OCP 1Z0-829 & 1Z0-830) with Confidence through our Practice Exams
  </h1>

  {/* Features List */}
  {/* Features List + OCA Cross-Promo - Two Column Layout */}
  <div className="features-oca-grid" style={{
    display: 'grid',
    gridTemplateColumns: window.innerWidth > 968 ? '1.3fr 1fr' : '1fr',
    gap: '24px',
    marginBottom: '24px',
    alignItems: 'stretch'
  }}>
    
    {/* LEFT: Features List */}
    <div className="header-maintenance" style={{
      fontSize: '20px',
      fontWeight: '600',
      color: '#111010ff',
    }}>
      <ul style={{ 
        listStyle: 'disc',
        paddingLeft: '20px',
        lineHeight: '1.8',
        color: '#22b037',
        fontSize: '18px',
        margin: 0
      }}>
        <li><strong>1,884 Java 17 (1Z0-829)</strong> practice questions with detailed explanations</li>
        <li><strong>2,074 Java 21 (1Z0-830)</strong> practice questions with detailed explanations</li>
        <li><strong>78 full-length certification tests</strong> total — 37 for Java 17, 41 for Java 21</li>
        <li><strong>Choose Java 17 or Java 21</strong> at signup; switch anytime in the dashboard</li>
        <li>Timed exams simulating real Oracle certification conditions</li>
        <li>Modern cloud-native architecture for fast load times</li>
        <li>Single Page Application (SPA) — smooth navigation throughout</li>
        <li>Carefully reviewed questions for accurate exam preparation</li>
        <li>Performance tracking and completion certificates after passing</li>
      </ul>
    </div>

    {/* RIGHT: OCA Cross-Promotion Box */}
    <div style={{
      backgroundColor: '#f8fafc',
      borderRadius: '12px',
      padding: '24px',
      border: '2px solid #e0f2fe',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }}>
      
      {/* Top — Header */}
      <div>
        <div style={{
          display: 'inline-block',
          background: '#dbeafe',
          color: '#075985',
          padding: '4px 12px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: '600',
          marginBottom: '14px',
          border: '1px solid #bae6fd'
        }}>
          📚 ARE YOU NEW TO JAVA CERTIFICATION?
        </div>
        
        <h3 style={{
          fontSize: '20px',
          fontWeight: '700',
          color: '#f30808',
          margin: '0 0 10px 0',
          lineHeight: '1.3'
        }}>
          If you want to start with OCA Java 8 First, click the Javalearn button below, otherwise stay here and get started with OCP Java 17 or Java 21 practice tests!
        </h3>
        
        <p style={{
          fontSize: '14px',
          color: '#475569',
          lineHeight: '1.6',
          marginBottom: '14px'
        }}>
          
        </p>
        
        {/* OCA Stats */}
        <div style={{
          backgroundColor: '#ffffff',
          padding: '12px 16px',
          borderRadius: '8px',
          marginBottom: '16px',
          borderLeft: '4px solid #0284c7'
        }}>
          <ul style={{
            listStyle: 'none',
            padding: 0,
            margin: 0,
            fontSize: '13px',
            color: '#334155',
            lineHeight: '1.8'
          }}>
            <li>✓ <strong>1,624 OCA practice questions</strong></li>
            <li>✓ <strong>29 full certification tests</strong></li>
            <li>✓ Free 30-question trial</li>
            <li>✓ Same pricing (₹1,400 / $16)</li>
          </ul>
        </div>
      </div>
      
      {/* Bottom — CTA */}
      <div style={{ textAlign: 'center' }}>
        <a
          href="https://javalearn.clustermicro.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '11px 24px',
            backgroundColor: '#e42929',
            color: '#ffffff',
            textDecoration: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            boxShadow: '0 2px 8px rgba(2, 132, 199, 0.3)',
            width: '100%',
            textAlign: 'center',
            boxSizing: 'border-box'
          }}
        >
          Visit JavaLearn (OCA Java 8) →
        </a>
        <p style={{
          fontSize: '11px',
          color: '#64748b',
          margin: '8px 0 0 0',
          fontStyle: 'italic'
        }}>
          Practice 1Z0-808 — Java 8 Foundation
        </p>
      </div>
    </div>
    
  </div>
  {/* Description */}
  <p className="header-description" style={{
    fontSize: '18px',
    marginBottom: '0',
    lineHeight: '1.7',
    color: '#374151',
  }}>
    Though it's the age of AI, companies still prefer certified professionals. Transform your programming career through globally recognized Java certification programs.
    Use <strong style={{ color: '#24c811ff' }}>
      Javaocp.clustermicro.com
    </strong> to practice and prepare for both{' '}
    <strong style={{ color: '#24c811ff' }}>
      Java 17 OCP (1Z0-829)
    </strong>{' '}
    and{' '}
    <strong style={{ color: '#3b82f6' }}>
      Java 21 OCP (1Z0-830)
    </strong>{' '}
    examinations using{' '}
    <strong style={{ color: '#24c811ff' }}>
      nearly 4,000 timed practice questions across 78 full-length tests
    </strong>!
  </p>
</div>

{/* TWO COLUMN SECTION: Exam Types + Study Modes | Get Started */}
<div className="two-column-grid" style={{
  display: 'grid',
  gridTemplateColumns: '1.2fr 0.8fr',
  gap: '18px',
  marginBottom: '18px',
  alignItems: 'stretch'
}}>
  
  {/* LEFT: Exam Types + Study Modes */}
  <div style={{
  display: 'flex',
  flexDirection: 'column',
  height: '100%'   // ✅ critical
}}>
    {/* Exam Types */}
    {/* Exam Types */}
<div style={{
  backgroundColor: '#ffffff',
  padding: '32px',
  borderRadius: '12px',
  border: '1px solid rgba(0,0,0,0.1)',
  boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
  marginBottom: '18px'
}}>
  <h3 style={{
    fontSize: '22px',
    fontWeight: '700',
    marginBottom: '20px',
    color: '#000000',
  }}>
    Exam Types
  </h3>

  <div style={{ display: 'grid', gap: '16px' }}>
    {[
      {
        title: 'Certification Test',
        desc: '50 questions · 90 minutes · 78 fixed test sets total (37 for Java 17, 41 for Java 21)',
      },
      {
        title: 'Random Practice',
        desc: '50 questions · 90 minutes · Randomly selected from your chosen Java version',
      },
      {
        title: 'Mixed Practice',
        desc: '50 questions · ~90 minutes · Balanced across all chapters of your version',
      },
    ].map((item, idx) => (
      <div
        key={idx}
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          padding: '16px',
          backgroundColor: '#f6f6f6ff',
          borderRadius: '8px',
          border: '1px solid rgba(0,0,0,0.05)',
          boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
        }}
      >
        <div>
          <div style={{
            fontSize: '15px',
            fontWeight: '600',
            marginBottom: '4px',
            color: '#000000',
          }}>
            {item.title}
          </div>
          <div style={{ fontSize: '14px', color: '#374151' }}>{item.desc}</div>
        </div>
      </div>
    ))}
  </div>
</div>

    {/* Study Modes - Combined */}
    <div style={{
      //backgroundColor: '#fbedd8ff',

      backgroundColor: '#ffffff',
      padding: '32px',
      borderRadius: '12px',
      border: '1px solid rgba(0,0,0,0.1)',
      boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
      flexGrow: 1,
    }}>
      <h3 style={{
        fontSize: '22px',
        fontWeight: '700',
        marginBottom: '20px',
        color: '#000000',
      }}>
        Study Modes
      </h3>

      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
      }}>
        {/* Practice Mode */}
        <div style={{
          backgroundColor: 'rgba(242, 242, 242, 0.1)',
          padding: '16px',
          borderRadius: '8px',
          border: '1px solid rgba(16, 185, 129, 0.25)',
        }}>
          <div style={{
            fontSize: '14px',
            fontWeight: '600',
            marginBottom: '8px',
            color: '#065f46',
          }}>
            📚 Practice Mode
          </div>
          <ul style={{ margin: 0, padding: 0, listStyle: 'none', color: '#000000', fontSize: '13px' }}>
            <li style={{ marginBottom: '4px' }}>✓ Explanations immediately</li>
            <li style={{ marginBottom: '4px' }}>✓ Learn as you practice</li>
            <li>✓ No time pressure</li>
          </ul>
        </div>

        {/* Exam Mode */}
        <div style={{
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          padding: '16px',
          borderRadius: '8px',
          border: '1px solid rgba(239, 68, 68, 0.25)',
        }}>
          <div style={{
            fontSize: '14px',
            fontWeight: '600',
            marginBottom: '8px',
            color: '#7f1d1d',
          }}>
            ⏱️ Exam Mode
          </div>
          <ul style={{ margin: 0, padding: 0, listStyle: 'none', color: '#000000', fontSize: '13px' }}>
            <li style={{ marginBottom: '4px' }}>✓ Real exam conditions</li>
            <li style={{ marginBottom: '4px' }}>✓ No explanations</li>
            <li>✓ Timed experience</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

          {/* RIGHT: Get Started */}
          <div style={{...styles.card, padding: '45px', backgroundColor: '#ffffff'}}>
            <h2 style={{
              fontSize: '28px',
              fontWeight: 'bold',
              margin: '0 0 8px 0',
              textAlign: 'center',
              color: '#111827'
            }}>
              Get Started
            </h2>
            
            <p style={{
              textAlign: 'center',
              color: '#111827',
              fontSize: '14px',
              marginBottom: '22px'
            }}>
              Join thousands of developers preparing for certification
            </p>

            <button
              onClick={() => setCurrentPage('register')}
              style={{...styles.primaryButton, marginBottom: '18px'}}
            >
              Create Account
            </button>
            
            <button
              onClick={() => setCurrentPage('login')}
              style={{...styles.secondaryButton, width: '100%'}}
            >
              Already have an account? Login
            </button>
            
            <div style={{
  marginTop: '16px',
  paddingTop: '24px',
  borderTop: '1px solid #e5e7eb',
  backgroundColor: '#f5f5f5',
}}>
  <h3 style={{
    fontSize: '15px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '16px',
    textAlign: 'center'
  }}>
    ✅ What's Included:
  </h3>
  <ul style={{
    fontSize: '14px',
    color: '#111827',
    lineHeight: '2',
    paddingLeft: '20px',
    margin: 0
  }}>
    <li>Full-length realistic exams for both Java 17 & 21</li>
    <li><strong>1,884 Java 17 questions and 2,074 Java 21 questions</strong>, with significant cross-version coverage</li>
    <li>Performance analytics showing where to focus your study</li>
    <li>Unlimited attempts for 6 months to build exam confidence</li>
    <li>Version selector to practice for either or both certifications</li>
    <li>Certificate access and history available with full subscription</li>
  </ul>
</div>
            
            <div style={{
  marginTop: '24px',
  padding: '16px',
  backgroundColor: '#f5f5f5',
  borderRadius: '8px',
  textAlign: 'center'
}}>
  <div style={{fontSize: '24px', fontWeight: 'bold', color: '#111827', marginBottom: '4px'}}>
    From ₹1,400 / $16
  </div>
  <div style={{
    fontSize: '13px',
    color: '#111827'
  }}>
    One-time payment • 6 months unlimited access • Both Java 17 & 21
  </div>
  {/* 🎁 Free trial note */}
  <div style={{
    marginTop: '12px',
    padding: '12px',
    backgroundColor: '#f0fdf4',
    borderRadius: '8px',
    border: '1px solid #bbf7d0'
  }}>
    <span style={{ marginRight: '8px' }}>🎁</span>
    <span style={{ fontSize: '14px', color: '#166534' }}>
      <strong>For Free Trial (30 Questions)</strong>, please create an account first!
    </span>
  </div>
</div>
          </div>
        </div>

        {/* FULL WIDTH SECTIONS */}
        <HeroSection />

      </div>
    </div>
  );
}

  // Registration Page
  if (currentPage === 'register') {
    return (
      <div style={styles.container}>
        <div style={{maxWidth: '500px', margin: '0 auto', padding: '40px 20px'}}>
          <div style={{...styles.card, padding: '40px', backgroundColor: '#ffffff'}}>
            <h2 style={{fontSize: '28px', fontWeight: 'bold', margin: '0 0 32px 0', textAlign: 'center'}}>
              Create Your Account
            </h2>

            {error && (
              <div style={{
                backgroundColor: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '24px',
                color: '#dc2626'
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleRegister}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Full Name</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  style={styles.input}
                  placeholder="Enter your full name"
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Email Address</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  style={styles.input}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Password</label>
                <div style={{position: 'relative'}}>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                    style={styles.input}
                    placeholder="Create a strong password (8-128 characters)"
                    minLength={8}
                    maxLength={128}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '12px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#6b7280'
                    }}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
                
                <PasswordStrengthIndicator 
                  password={formData.password} 
                  showRequirements={formData.password.length > 0}
                />
              </div>

              <button
                type="submit"
                disabled={isLoading}
                style={{
                  ...styles.primaryButton,
                  opacity: isLoading ? 0.7 : 1,
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  marginBottom: '16px'
                }}
              >
                {isLoading ? 'Creating Account...' : 'Create Account'}
              </button>

              <button
                type="button"
                onClick={() => setCurrentPage('login')}
                style={{...styles.secondaryButton, width: '100%'}}
              >
                Already have an account? Login
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  // Login Page
  if (currentPage === 'login') {
    return (
      <div style={styles.container}>
        <div style={{maxWidth: '500px', margin: '0 auto', padding: '40px 20px'}}>
          <div style={{...styles.card, padding: '40px', backgroundColor: '#ffffff'}}>
            <h2 style={{fontSize: '28px', fontWeight: 'bold', margin: '0 0 32px 0', textAlign: 'center'}}>
              Welcome Back
            </h2>

            {error && (
              <div style={{
                backgroundColor: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '24px',
                color: '#dc2626'
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleLogin}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Email Address</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  style={styles.input}
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Password</label>
                <div style={{position: 'relative'}}>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                    style={styles.input}
                    placeholder="Enter your password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '12px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#6b7280'
                    }}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>
              
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                <button
                  type="button"
                  onClick={handleForgotPasswordClick}
                  style={{
                    fontSize: '14px',
                    color: '#667eea',
                    backgroundColor: 'transparent',
                    border: 'none',
                    fontWeight: '500',
                    cursor: 'pointer',
                    padding: '4px 0',
                    transition: 'color 0.3s'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#5568d3'}
                  onMouseOut={(e) => e.target.style.color = '#667eea'}
                >
                  Forgot Password?
                </button>
              </div>
              
              <button
                type="submit"
                disabled={isLoading}
                style={{
                  ...styles.primaryButton,
                  opacity: isLoading ? 0.7 : 1,
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  marginBottom: '16px'
                }}
              >
                {isLoading ? 'Signing In...' : 'Sign In'}
              </button>

              <button
                type="button"
                onClick={() => setCurrentPage('register')}
                style={{...styles.secondaryButton, width: '100%'}}
              >
                Don't have an account? Register
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }



// UPDATED PAYMENT PAGE - Side-by-Side Payment Options
// Replace your "if (currentPage === 'payment')" section in App.js with this:

if (currentPage === 'payment') {
  return (
    <div style={styles.container}>
      <div style={{maxWidth: '1200px', margin: '0 auto', padding: '40px 20px'}}>
        
        {/* Header */}
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px'}}>
          <div style={{display: 'flex', alignItems: 'center', color: '#111827'}}>
            <User style={{marginRight: '8px'}} size={24} />
            <span style={{fontSize: '18px', fontWeight: '600'}}>{user?.name}</span>
          </div>
          <button
            onClick={handleLogout}
            style={{...styles.secondaryButton, backgroundColor: 'rgba(255,255,255,0.9)', color: '#667eea'}}
          >
            <LogOut style={{marginRight: '8px'}} size={16} />
            Logout
          </button>
        </div>

        {/* Page Title */}
        <div style={{textAlign: 'center', marginBottom: '40px'}}>
          <h1 style={{
            fontSize: '36px',
            fontWeight: 'bold',
            color: '#111827',
            marginBottom: '12px'
          }}>
            Choose Your Plan
          </h1>
          <p style={{
            fontSize: '18px',
            color: '#374151'
          }}>
            Start with a free trial or unlock full access to Java 17 or Java 21
          </p>
        </div>

        {/* Payment Options Grid - 3 Cards */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth > 968 ? 'repeat(3, 1fr)' : '1fr',
          gap: '24px',
          marginBottom: '40px'
        }}>
          
          {/* FREE TRIAL CARD */}
          <div style={{...styles.card, padding: '40px', position: 'relative', overflow: 'hidden'}}>
            <div style={{
              position: 'absolute',
              top: '20px',
              right: '-30px',
              backgroundColor: '#10b981',
              color: 'white',
              padding: '6px 40px',
              transform: 'rotate(45deg)',
              fontSize: '12px',
              fontWeight: 'bold',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
            }}>
              FREE
            </div>

            <div style={{textAlign: 'center', marginBottom: '32px'}}>
              <div style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px auto'
              }}>
                <Gift color="white" size={40} />
              </div>
              
              <h2 style={{fontSize: '24px', fontWeight: 'bold', margin: '0 0 8px 0'}}>
                Free Trial
              </h2>
              
              <div style={{
                fontSize: '48px',
                fontWeight: 'bold',
                color: '#10b981',
                margin: '16px 0'
              }}>
                30
              </div>
              
              <p style={{color: '#64748b', margin: 0, fontSize: '16px'}}>
                Practice Questions
              </p>
            </div>

            <div style={{
              backgroundColor: '#f0fdf4',
              padding: '20px',
              borderRadius: '12px',
              marginBottom: '24px',
              minHeight: '200px'
            }}>
              <h3 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#166534',
                marginBottom: '12px'
              }}>
                ✅ What's Included:
              </h3>
              <ul style={{
                fontSize: '14px',
                color: '#166534',
                lineHeight: '2',
                paddingLeft: '20px',
                margin: 0
              }}>
                <li>30 practice questions</li>
                <li>Mixed practice mode</li>
                <li>Instant scoring</li>
                <li>Answer explanations</li>
                <li>No credit card needed</li>
              </ul>
            </div>

            {trialError && (
              <div style={{
                backgroundColor: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '12px',
                padding: '12px',
                marginBottom: '16px',
                fontSize: '14px',
                color: '#dc2626'
              }}>
                {trialError}
              </div>
            )}

            <button
              onClick={handleActivateFreeTrial}
              disabled={isLoading}
              style={{
                width: '100%',
                padding: '16px',
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                opacity: isLoading ? 0.7 : 1,
                boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)',
                transition: 'all 0.3s ease'
              }}
            >
              {isLoading ? 'Activating...' : '🎁 Start Free Trial'}
            </button>

            <p style={{
              textAlign: 'center',
              fontSize: '12px',
              color: '#64748b',
              marginTop: '12px'
            }}>
              No payment required
            </p>
          </div>

          {/* JAVA 17 OCP CARD */}
          <div style={{...styles.card, padding: '40px', position: 'relative', overflow: 'hidden'}}>
            <div style={{
              position: 'absolute',
              top: '20px',
              right: '-30px',
              backgroundColor: '#ffffff',
              color: '#111827',
              border: '1px solid #e5e7eb',
              padding: '6px 40px',
              transform: 'rotate(45deg)',
              fontSize: '12px',
              fontWeight: 'bold'
            }}>
              JAVA 17
            </div>

            <div style={{textAlign: 'center', marginBottom: '32px'}}>
              <div style={{
                width: '80px',
                height: '80px',
                background: '#f9fafb',
                border: '1px solid #e5e7eb',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px auto'
              }}>
                <Trophy color="#10b981" size={40} />
              </div>
              
              <h2 style={{fontSize: '24px', fontWeight: 'bold', margin: '0 0 8px 0'}}>
                Java 17 OCP
              </h2>
              
              <div style={{fontSize: '48px', fontWeight: 'bold', color: '#111827', margin: '16px 0'}}>
                ₹1,400
              </div>
              
              <p style={{fontSize: '16px', color: '#0d0d0dff'}}>
                One-time • 6 months
              </p>
            </div>

            <div style={{
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              color: '#374151',
              padding: '20px',
              borderRadius: '12px',
              marginBottom: '16px',
              minHeight: '200px'
            }}>
              <ul style={{fontSize: '14px', color: '#070707ff', lineHeight: '2', paddingLeft: '20px', margin: 0}}>
                <li>1,850 practice questions</li>
                <li>37 certification tests</li>
                <li>1Z0-829 exam prep</li>
                <li>Records, Sealed Classes, Pattern Matching</li>
                <li>+ JDBC (not in 1Z0-830)</li>
                <li>+ JPMS, Concurrency, Localization</li>
              </ul>
            </div>

            <div style={{
              padding: '12px',
              backgroundColor: '#f9fafb',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              marginBottom: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Shield 
                size={16} 
                style={{ 
                  marginRight: '8px', 
                  color: '#0c0c0cff',
                  flexShrink: 0 
                }} 
              />
              <p style={{
                margin: 0,
                fontSize: '13px',
                color: '#070707ff',
                fontWeight: '600',
                lineHeight: '1.4'
              }}>
                Secure Payment Gateway
              </p>
            </div>

            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
              {/* Razorpay for India */}
              <button
                onClick={async () => {
                  setIsLoading(true);
                  setPaymentError(null);
                  try {
                    const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/create-subscription`, {
                      method: 'POST',
                      body: JSON.stringify({ 
                        currency: 'INR', 
                        amount: 1400,
                        javaVersion: '17',
                        environment: process.env.NODE_ENV === 'production' ? 'live' : 'test'
                      })
                    });
                    if (!response.ok) throw new Error(`HTTP ${response.status}`);
                    const data = await response.json();
                    if (data.orderId) {
                      initiateRazorpayCheckout(data);
                    }
                  } catch (error) {
                    if (error.message === 'SESSION_INVALID') return;
                    setPaymentError(error.message);
                  } finally {
                    setIsLoading(false);
                  }
                }}
                disabled={isLoading}
                style={{
                  width: '100%',
                  padding: '14px',
                  background: '#e5e7eb',
                  color: '#111827',
                  border: '1px solid #d1d5db',
                  borderRadius: '10px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  opacity: isLoading ? 0.7 : 1
                }}
              >
                Pay ₹1,400 (Razorpay)
              </button>

              {/* PayPal for International */}
              <button
                onClick={async () => {
                  setIsLoading(true);
                  setPaymentError(null);
                  try {
                    const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/create-paypal-order`, {
                      method: 'POST',
                      body: JSON.stringify({ 
                        currency: 'USD', 
                        amount: 16,
                        javaVersion: '17',
                        environment: process.env.NODE_ENV === 'production' ? 'live' : 'sandbox'
                      })
                    });
                    if (!response.ok) throw new Error(`HTTP ${response.status}`);
                    const data = await response.json();
                    if (data.approvalUrl) {
                      window.location.href = data.approvalUrl;
                    }
                  } catch (error) {
                    if (error.message === 'SESSION_INVALID') return;
                    setPaymentError(error.message);
                  } finally {
                    setIsLoading(false);
                  }
                }}
                disabled={isLoading}
                style={{
                  width: '100%',
                  padding: '14px',
                  background: '#e5e7eb',
                  color: '#111827',
                  border: '1px solid #d1d5db',
                  borderRadius: '10px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  opacity: isLoading ? 0.7 : 1
                }}
              >
                Pay $16 (PayPal)
              </button>
            </div>

            <p style={{
              textAlign: 'center',
              fontSize: '11px',
              color: '#0b0b0bff',
              marginTop: '10px'
            }}>
              UPI • Cards • Net Banking • Wallets
            </p>
          </div>

          {/* JAVA 21 OCP CARD */}
          <div style={{...styles.card, padding: '40px', position: 'relative', overflow: 'hidden'}}>
            <div style={{
              position: 'absolute',
              top: '20px',
              right: '-30px',
              backgroundColor: '#111827',
              color: 'white',
              padding: '6px 40px',
              transform: 'rotate(45deg)',
              fontSize: '12px',
              fontWeight: 'bold'
            }}>
              JAVA 21
            </div>

            {/* NEW Badge */}
            <div style={{
              position: 'absolute',
              top: '70px',
              right: '20px',
              backgroundColor: '#ef4444',
              color: 'white',
              padding: '4px 12px',
              borderRadius: '12px',
              fontSize: '11px',
              fontWeight: 'bold',
              boxShadow: '0 2px 6px rgba(239, 68, 68, 0.4)',
              animation: 'pulse 2s infinite'
            }}>
              NEW
            </div>

            <div style={{textAlign: 'center', marginBottom: '32px'}}>
              <div style={{
                width: '80px',
                height: '80px',
                background: '#f3f4f6',
                border: '1px solid #e5e7eb',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px auto'
              }}>
                <Award color="#3b82f6" size={40} />
              </div>
              
              <h2 style={{fontSize: '24px', fontWeight: 'bold', margin: '0 0 8px 0'}}>
                Java 21 OCP
              </h2>
              
              <div style={{fontSize: '48px', fontWeight: 'bold', color: '#111827', margin: '16px 0'}}>
                ₹1,400
              </div>
              
              <p style={{fontSize: '16px', color: '#010101ff'}}>
                One-time • 6 months
              </p>
            </div>

            <div style={{
              backgroundColor: '#f8f9ff',
              padding: '20px',
              borderRadius: '12px',
              marginBottom: '16px',
              minHeight: '200px'
            }}>
              <ul style={{fontSize: '14px', color: '#111827', lineHeight: '2', paddingLeft: '20px', margin: 0}}>
              <li>2,050 practice questions</li>
              <li>41 certification tests</li>
              <li>1Z0-830 exam prep</li>
              <li>Records, Sealed Classes, Pattern Matching</li>
              <li>+ Virtual Threads & Structured Concurrency</li>
              <li>+ Sequenced Collections & Record Patterns</li>
              <li>— No JDBC (removed in 1Z0-830)</li>
            </ul>
            </div>

            <div style={{
              padding: '12px',
              backgroundColor: '#f3f4f6',
              borderRadius: '8px',
              marginBottom: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <Shield 
                size={16} 
                style={{ 
                  marginRight: '8px', 
                  color: '#374151',
                  flexShrink: 0 
                }} 
              />
              <p style={{
                margin: 0,
                fontSize: '13px',
                color: '#090909ff',
                fontWeight: '600',
                lineHeight: '1.4'
              }}>
                Secure Payment Gateway
              </p>
            </div>

            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
              {/* Razorpay for India */}
              <button
                onClick={async () => {
                  setIsLoading(true);
                  setPaymentError(null);
                  try {
                    const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/create-subscription`, {
                      method: 'POST',
                      body: JSON.stringify({ 
                        currency: 'INR', 
                        amount: 1400,
                        javaVersion: '21',
                        environment: process.env.NODE_ENV === 'production' ? 'live' : 'test'
                      })
                    });
                    if (!response.ok) throw new Error(`HTTP ${response.status}`);
                    const data = await response.json();
                    if (data.orderId) {
                      initiateRazorpayCheckout(data);
                    }
                  } catch (error) {
                    if (error.message === 'SESSION_INVALID') return;
                    setPaymentError(error.message);
                  } finally {
                    setIsLoading(false);
                  }
                }}
                disabled={isLoading}
                style={{
                  width: '100%',
                  padding: '14px',
                  background: '#e5e7eb',
                  color: '#111827',
                  border: '1px solid #d1d5db',
                  borderRadius: '10px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  opacity: isLoading ? 0.7 : 1
                }}
              >
                Pay ₹1,400 (Razorpay)
              </button>

              {/* PayPal for International */}
              <button
                onClick={async () => {
                  setIsLoading(true);
                  setPaymentError(null);
                  try {
                    const response = await makeAuthenticatedRequest(`${API_ENDPOINT}/create-paypal-order`, {
                      method: 'POST',
                      body: JSON.stringify({ 
                        currency: 'USD', 
                        amount: 16,
                        javaVersion: '21',
                        environment: process.env.NODE_ENV === 'production' ? 'live' : 'sandbox'
                      })
                    });
                    if (!response.ok) throw new Error(`HTTP ${response.status}`);
                    const data = await response.json();
                    if (data.approvalUrl) {
                      window.location.href = data.approvalUrl;
                    }
                  } catch (error) {
                    if (error.message === 'SESSION_INVALID') return;
                    setPaymentError(error.message);
                  } finally {
                    setIsLoading(false);
                  }
                }}
                disabled={isLoading}
                style={{
                  width: '100%',
                  padding: '14px',
                  background: '#e5e7eb',
                  color: '#111827',
                  border: '1px solid #d1d5db',
                  borderRadius: '10px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  opacity: isLoading ? 0.7 : 1
                }}
              >
                Pay $16 (PayPal)
              </button>
            </div>

            <p style={{
              textAlign: 'center',
              fontSize: '11px',
              color: '#6b7280',
              marginTop: '10px'
            }}>
              Credit Cards • Debit Cards • PayPal Balance
            </p>
          </div>

        </div>

        {/* Error Display */}
        {paymentError && (
          <div style={{
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            borderRadius: '12px',
            padding: '16px',
            marginTop: '24px',
            fontSize: '14px',
            color: '#dc2626',
            textAlign: 'center',
            maxWidth: '600px',
            margin: '24px auto'
          }}>
            {paymentError}
          </div>
        )}

      </div>

      {/* Animation for NEW badge */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.05);
          }
        }
      `}</style>
    </div>
  );
}


  // Dashboard Page
 // Dashboard Page
if (currentPage === 'dashboard') {
  return (
    <div style={styles.container}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '20px'
      }}>
        {/* Header Section */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '24px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
            <User style={{ marginRight: '8px' }} size={32} />
            <span style={{ fontSize: '18px', fontWeight: '600' }}>{user?.name}</span>
          </div>
          {/* Header Right Section */}
{/* Header Right Section */}
<div style={{ display: 'flex', gap: '12px' }}>
  {/* View Certificates */}
  <button
    onClick={() => {
      if (user?.subscriptionType !== 'trial') {
        setCurrentPage('certificates');
      }
    }}
    disabled={user?.subscriptionType === 'trial'}
    style={{
      ...styles.secondaryButton,
      backgroundColor: 'rgba(255,255,255,0.9)',
      color: user?.subscriptionType === 'trial' ? '#94a3b8' : '#667eea',
      border: `2px solid ${user?.subscriptionType === 'trial' ? '#cbd5e1' : '#667eea'}`,
      cursor: user?.subscriptionType === 'trial' ? 'not-allowed' : 'pointer',
      opacity: user?.subscriptionType === 'trial' ? 0.6 : 1
    }}
    title={
      user?.subscriptionType === 'trial'
        ? 'Available only with full subscription'
        : 'View your earned certificates'
    }
  >
    <Trophy style={{ marginRight: '8px' }} size={16} />
    View Certificates
  </button>

  {/* Logout */}
  {/* <button
    onClick={handleLogout}
    style={{
      ...styles.secondaryButton,
      backgroundColor: 'rgba(255,255,255,0.9)',
      color: '#667eea'
    }}
  >
    <LogOut style={{ marginRight: '8px' }} size={16} />
    Logout
  </button> */}
</div>


        </div>

        {/* Chapter Selector (main content) */}
        <ChapterExamSelector 
          onStartExam={handleStartExam}
          user={user}
          onLogout={handleLogout}
          selectedJavaVersion={selectedJavaVersion}           // ✅ NEW
          setSelectedJavaVersion={setSelectedJavaVersion}     // ✅ NEW
        />
      </div>
    </div>
  );
}


  // Certificates Page
if (currentPage === 'certificates') {
  return (
    <div style={styles.container}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '20px'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '24px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
            <User style={{ marginRight: '8px' }} size={32} />
            <span style={{ fontSize: '18px', fontWeight: '600' }}>{user?.name}</span>
          </div>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={() => setCurrentPage('dashboard')}
              style={{...styles.secondaryButton, backgroundColor: 'rgba(255,255,255,0.9)', color: '#667eea'}}
            >
              Back to Dashboard
            </button>
            <button
              onClick={handleLogout}
              style={{...styles.secondaryButton, backgroundColor: 'rgba(255,255,255,0.9)', color: '#667eea'}}
            >
              <LogOut style={{ marginRight: '8px' }} size={16} />
              Logout
            </button>
          </div>
        </div>

        <CertificateGenerator 
  user={user} 
  examHistory={examHistory}
  apiEndpoint={API_ENDPOINT}
  authToken={authToken}
/>

      </div>
    </div>
  );
}

  // Exam Page
  if (currentPage === 'exam' && questions.length > 0 && !examSubmitted) {
    return (
      <div style={styles.container}>
        <ExamInterface
          questions={questions}
          onSubmitExam={handleSubmitExam}
          timeRemaining={timeRemaining}
          setTimeRemaining={setTimeRemaining}
          user={user}
          examConfig={examConfig}
          onLogout={handleLogout}
        />
      </div>
    );
  }

  // Review Mistakes Page
  if (currentPage === 'review' && lastAttempt) {
    console.log("📘 Rendering ExamReview page for last attempt");
    return (
      <div style={{ backgroundColor: '#f3f4f6', minHeight: '100vh', padding: '20px' }}>
        <ExamReview
          attempt={lastAttempt}
          onBack={() => {
            console.log("⬅️ Returning to results page");
            setCurrentPage('results');
          }}
        />
      </div>
    );
  }

  // Results Page
  if (currentPage === 'results' || examSubmitted) {
    const totalQuestions = questions.length;
    const percentage = totalQuestions > 0 ? ((score / totalQuestions) * 100).toFixed(1) : 0;
    const passed = parseFloat(percentage) >= 65;
    const examTypeLabel = EXAM_TYPE_LABELS[examConfig?.type] || "Unknown Type";

    return (
      <div style={styles.container}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
            <div style={{ display: 'flex', alignItems: 'center', color: 'white' }}>
              <User style={{ marginRight: '8px' }} size={32} />
              <span style={{ fontSize: '18px', fontWeight: '600' }}>{user?.name}</span>
            </div>
            <button
              onClick={handleLogout}
              style={{ ...styles.secondaryButton, backgroundColor: 'rgba(255,255,255,0.9)', color: '#667eea' }}
            >
              <LogOut style={{ marginRight: '8px' }} size={16} />
              Logout
            </button>
          </div>

          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ ...styles.card, padding: '40px' }}>
              <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                {passed ? (
                  <>
                    <Trophy style={{ color: '#f59e0b', margin: '0 auto 16px auto' }} size={96} />
                    <h1
                      style={{
                        fontSize: '36px',
                        fontWeight: 'bold',
                        margin: '0 0 16px 0',
                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                      }}
                    >
                      Congratulations!
                    </h1>
                    <p style={{ fontSize: '20px', color: '#64748b' }}>
                      You passed the {examTypeLabel} Exam!
                    </p>
                  </>
                ) : (
                  <>
                    <TrendingUp style={{ color: '#f59e0b', margin: '0 auto 16px auto' }} size={96} />
                    <h1 style={{ fontSize: '36px', fontWeight: 'bold', margin: '0 0 16px 0' }}>Exam Complete</h1>
                    <p style={{ fontSize: '20px', color: '#64748b' }}>Keep practicing to improve your score</p>
                  </>
                )}
              </div>

              <div
                style={{
                  padding: '32px',
                  backgroundColor: '#f8fafc',
                  borderRadius: '16px',
                  marginBottom: '32px',
                }}
              >
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '32px',
                    textAlign: 'center',
                  }}
                >
                  <div>
                    <p style={{ color: '#64748b', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                      Your Score
                    </p>
                    <p style={{ fontSize: '48px', fontWeight: 'bold', color: '#667eea', margin: 0 }}>
                      {score}/{totalQuestions}
                    </p>
                  </div>
                  <div>
                    <p style={{ color: '#64748b', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                      Percentage
                    </p>
                    <p style={{ fontSize: '48px', fontWeight: 'bold', color: '#8b5cf6', margin: 0 }}>{percentage}%</p>
                  </div>
                </div>

                <div
                  style={{
                    marginTop: '20px',
                    paddingTop: '20px',
                    borderTop: '1px solid #e2e8f0',
                    textAlign: 'center',
                  }}
                >
                  <p style={{ color: '#64748b', fontSize: '14px', margin: '0' }}>
                    Exam Type: <strong>{examTypeLabel}</strong>
                  </p>
                  {examConfig?.chapter && (
                    <p style={{ color: '#64748b', fontSize: '12px', margin: '4px 0 0 0' }}>
                      Chapter Focus: {examConfig.chapter}
                    </p>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
                <button
                  onClick={() => {
                    setExamSubmitted(false);
                    setScore(0);
                    setError(null);
                    setCurrentPage('dashboard');
                  }}
                  style={{ ...styles.primaryButton, flex: 1, minWidth: '200px' }}
                >
                  Take Another Exam
                </button>

                <button
                  onClick={() => setCurrentPage('dashboard')}
                  style={{ ...styles.secondaryButton, padding: '16px 32px' }}
                >
                  Back to Dashboard
                </button>

                {lastAttempt && (
                  <button
                    onClick={() => setCurrentPage('review')}
                    style={{
                      ...styles.secondaryButton,
                      backgroundColor: '#fef3c7',
                      color: '#92400e',
                      border: '1px solid #fcd34d',
                    }}
                  >
                    Review Mistakes
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showForgotPassword || currentPage === 'forgot-password') {
    return (
      <ForgotPassword 
        onBack={handleBackToLogin}
        apiEndpoint={API_ENDPOINT}
      />
    );
  }

  if (showResetPassword || currentPage === 'reset-password') {
    return (
      <ResetPassword 
        apiEndpoint={API_ENDPOINT}
        onSuccess={handleResetPasswordSuccess}
        onBack={handleBackToLogin}
      />
    );
  }

  return null;
}

export default App;